// Plan firmy w panelu (FAZA F). Wyłącznie wygląd: o dostępie rozstrzyga serwer
// (Login/backend/lib/plans.js, 403 `premium_required`). Super-admin widzi każdą funkcję,
// tak jak przechodzi bramki planu na serwerze (decyzja 2026-09-26).
// Plan zapisują w localStorage logowanie (login/Login.js) i start aplikacji z /api/whoami
// (App.js przez utils/sessionSync.js#zapiszFlagiSesji); odczyt może rzucić (prywatne okno).

function czytaj(klucz) {
  try {
    return window.localStorage.getItem(klucz);
  } catch (_) {
    return null;
  }
}

// `planFirmy`: plan z odpowiedzi serwera na tym ekranie (`organizationPlan` z GET ustawień).
// Ma pierwszeństwo przed localStorage, który bywa sprzed zmiany planu w otwartej karcie.
export function maPremium(planFirmy = null, odczyt = czytaj) {
  if (odczyt('isSuperAdmin') === '1') return true;
  return (planFirmy || odczyt('subscriptionPlan')) === 'premium';
}

// Super-admin przechodzi bramki tras, ale wysyłka (własny SMTP, przypomnienia) zależy wyłącznie
// od planu firmy. Ekran mówi mu wtedy, że zapisane ustawienia nie zadziałają. Nieznany plan = nie.
export function superAdminFirmyBezPremium(planFirmy, odczyt = czytaj) {
  return odczyt('isSuperAdmin') === '1' && !!planFirmy && planFirmy !== 'premium';
}
